export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://zava.frb.io/graphql", "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie", "defaultOptions": undefined}}
}